import { create } from 'zustand'

import { JSON_FORM } from '#app/constants/forms.ts'
import { type State, type Action, type JSONState } from '#types/form/wizard.ts'

import { globalFormReducer } from './globalFormReducer.ts'

export type GlobalFormStore<T> = State<T> & {
	dispatch: (action: Action<T>) => void
}

export type GlobalFormJSONStore<T> = JSONState<T> & {
	dispatch: (action: Action<T>) => void
}

export type UseGlobalFormStore<T> = () => GlobalFormStore<T>

export function createGlobalJSONFormStore<T>() {
	return create<JSONState<T> & { dispatch: (action: Action<T>) => void }>(
		function (set) {
			return {
				type: JSON_FORM,
				fieldKey: '',
				formId: '',
				languageId: '',
				currentStep: 0,
				allSteps: 0,
				formHasBeenCompleted: false,
				includedControllerQuestions: [],
				formState: {} as T,
				oldFormState: {} as T,
				currentQuestionId: 'A1',
				currentQuestionTreeId: '',
				lastSetId: '',
				editableParents: [],
				currentScores: [],
				questionTree: [],
				isInJsonTree: false,
				answeredQuestionsStack: [],
				wizardMessages: [],
				dispatch: function (action: Action<T>) {
					set(function (state: JSONState<T>) {
						const newState = globalFormReducer({ state, action })
						if (newState.type !== 'JSON_FORM') {
							throw new Error('Expected JSON_FORM state')
						}
						return newState
					})
				},
			}
		},
	)
}

export const globalJSONStore = createGlobalJSONFormStore()

export function createGlobalFormStore<T>(initialState: State<T>) {
	return create<State<T> & { dispatch: (action: Action<T>) => void }>(
		function (set) {
			return {
				...initialState,
				dispatch: function (action: Action<T>) {
					set(function (state: State<T>) {
						return globalFormReducer({ state, action })
					})
				},
			} as GlobalFormStore<T>
		},
	)
}
